export default __webpack_public_path__ + "static/media/loader.162c108c.svg";